import { Search } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { useCommandPaletteStore } from '@/stores/commandPaletteStore'
import { cn } from '@/lib/utils'

/**
 * Opens the command palette by click, for the hands that never learn
 * Shift+Space. The palette's own footer carries the shortcut, so the button
 * stays a plain label.
 */
export function CommandPaletteButton({ className }: { className?: string }) {
  const openPalette = useCommandPaletteStore((s) => s.openPalette)

  return (
    <Button
      type="button"
      variant="secondary"
      onClick={openPalette}
      className={cn('gap-2', className)}>
      <Search />
      <span>Search</span>
    </Button>
  )
}
